import React from "react";
import WatchlistDashboardV2 from "./WatchlistDashboardV2";
import type { MarketValue } from "~types/portfolio";

type WatchlistDashboardProps = {
  marketValue: MarketValue;
  version: "v1" | "v2";
};

export default function WatchlistDashboard({
  marketValue,
}: WatchlistDashboardProps) {
  return <WatchlistDashboardV2 marketValue={marketValue} />;
}
